import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { type PermissionState } from "@capacitor/core";

export const usePushNotificationsPermissionStore = defineStore(
  "push-notification-permissions",
  () => {
    // State
    const _token = ref<string | null>(null);
    const _permissionState = ref<PermissionState | null>(null);
    const _permissionIsChecked = ref<boolean>(false);

    // Getters
    const token = computed(() => _token.value);
    const permissionIsChecked = computed(() => _permissionIsChecked.value);
    const permissionState = computed(() => _permissionState.value);
    const canAskPermission = computed(
      (): boolean =>
        !!_permissionState.value &&
        ["prompt", "prompt-with-rationale"].includes(_permissionState.value),
    );

    // Actions
    const setToken = (newToken: string | null) => {
      _token.value = newToken;
    };

    const setPermissionIsChecked = (checked: boolean) => {
      _permissionIsChecked.value = checked;
    };

    const setPermissionState = (state: PermissionState | null) => {
      _permissionState.value = state;
    };

    return {
      token,
      permissionIsChecked,
      permissionState,
      canAskPermission,
      setToken,
      setPermissionIsChecked,
      setPermissionState,
    };
  },
);
